angular.module('study.ecrd.field.queries').component('gridRowQueries', {
    templateUrl: 'modules/ecrd/components/field/queries/grid-row-queries/content.html',
    controller: 'GridRowQueriesController',
    bindings: {
        gridId: '@',
        rowIndex: '@',
    },
});
